<div class="form-group">
	<label for="exampleFormControlTextarea1">{{settings.label}}</label>
	<textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
</div>